import convertUnitToMap from 'helpers/convertUnitToMap'
import equals from 'ramda/src/equals'

export default function determineLocationOfNewDevice({ map, devices, isImperial }) {
  const mapCenter = map.getCenter().toJSON()

  const centeredDevice = devices.find(device => equals(device.location, mapCenter))

  if (!centeredDevice) return mapCenter

  const distance = centeredDevice.distance ? convertUnitToMap({ value: centeredDevice.distance, isImperial }) + 20 : 20
  const location = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(centeredDevice.location), distance, 90)

  map.setCenter(location)
  return location.toJSON()
}



// WEBPACK FOOTER //
// ./src/helpers/map/determineLocationOfNewDevice.js